import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6", 
    lg: "w-8 h-8"
  };

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-muted-foreground border-t-primary",
          sizeClasses[size]
        )}
        style={{ animationDuration: "var(--animation-normal)" }}
      />
    </div>
  );
}

interface LoadingSpinnerWithTextProps extends LoadingSpinnerProps {
  text?: string;
}

export function LoadingSpinnerWithText({ text = "جاري التحميل...", size = "md", className }: LoadingSpinnerWithTextProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3", className)}>
      <LoadingSpinner size={size} />
      <p className="text-sm text-muted-foreground animate-pulse">{text}</p>
    </div>
  );
}